// extracted by mini-css-extract-plugin
export default {"Input":"input_Input__CDdxn","Label":"input_Label__IAzWK"};